<template>
  <div class="input-label">
    <label
      class="input-label__text"
      :for="inputId"
    >
      {{ label }}
      <RequiredIcon
        v-if="requiredIcon"
        class="input-label__required-icon"
      />
    </label>
    <HelpTooltip
      v-if="getTooltipText || getTooltipImage"
      class="input-label__additional-info"
      :text="getTooltipText"
      :image="getTooltipImage"
      :image-alt="getTooltipImageAlt"
      :width="getTooltipWidth"
      :icon-color="getIconColor"
      :icon-hover-color="getIconHoverColor"
    />
  </div>
</template>

<script>
import HelpTooltip from '@/shared/ui/form/help-tooltip';
import { RequiredIcon } from '@/shared/ui/icons';

export default {
  components: { RequiredIcon, HelpTooltip },
  props: {
    label: {
      type: String,
      default: '',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    inputId: {
      type: String,
      required: true,
    },
  },
  computed: {
    getTooltipText() {
      return this.tooltip?.text || null;
    },
    getTooltipImage() {
      return this.tooltip?.image || null;
    },
    getTooltipImageAlt() {
      return this.tooltip?.imageAlt || null;
    },
    getTooltipWidth() {
      return this.tooltip?.width || null;
    },
    getIconColor() {
      return this.tooltip?.iconColor || '#E4E4E7';
    },
    getIconHoverColor() {
      return this.tooltip?.iconHoverColor || '#000000';
    },
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  &__text {
    display: flex;
    align-items: center;
    font-family: 'Geist', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #09090B;
  }

  &__required-icon {
    margin-top: -10px;
  }

  &__additional-info {
    margin-left: 2px;
  }
}
</style>
